import Vue from 'vue'
import App from './App.vue'
import router from './routes'
import './plugins/element.js'
import store from './store'
import dateTimePicker from '@/components/DateTimePicker'
import TableDate from '@/UI/components/TableDate'
import moment from 'vue-moment'
import api from './api/index'
import {showErrors} from 'uicommon/errors'
import Icon from '@/components/Icon'
import ItemViewTable from '@/components/ItemViewTable'
import 'element-ui/lib/theme-chalk/display.css'
import Report from '@/components/Report'
import Filters from '@/components/Filters'
import Card from '@/components/Card'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import routes from './routes/route'
import 'leaflet/dist/leaflet.css'

console.log("Запуск приложения")

let config = sessionStorage.getItem('config')
if (config === null) {
    console.log("Первый запуск, получаем конфиг")
    fetch(process.env.BASE_URL + "config.json")
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            console.log("Получили конфиг", data)
            sessionStorage.setItem('sberpay.api_token', data.sberpay.api_token)
            if (data.parkingApi) {
                console.log("Запрашиваем количество парковок", data.parkingApi)
                fetch(data.parkingApi + "/api/Parkings/")
                    .then((response) => {
                        return response.json()
                    })
                    .then((data1) => {
                        let arr = []
                        data1.Items.map((item) => {
                            arr.push({
                                name: item.Name,
                                endpoint: 'http://' + item.ServerAddress + ':10260'
                            })
                        })
                        let obj = {
                            discountApi: data.discountApi,
                            parkingApi: data.parkingApi,
                            parkings: arr
                        }
                        sessionStorage.setItem('parkings', JSON.stringify(data1.Items))
                        sessionStorage.setItem('config', JSON.stringify(obj))
                        location.reload()
                    }).catch (() => {
                        console.log('Сервер со списком парковок недоступен')
                        sessionStorage.setItem('config', JSON.stringify(data))
                        location.reload()
                    })
            }
            else {
                sessionStorage.setItem('config', JSON.stringify(data))
                location.reload()
            }
        })
    // eslint-disable-next-line no-undef
    throw "Первый запуск, перечитываем конфиг!"
}

console.log("Конфиг загружен")

Vue.prototype.$api = api
Vue.prototype.$version = process.env.Version
Vue.prototype.$colors = process.env.COLORS
Vue.$props = function (name, type, param) {
    let obj = {
        Name: name,
        ItemType: type,
        OperatorName: "Admin"
    }

    switch (name) {
        case "AddItem":
            obj.ItemProperties = []
            for (let row in param) {
                obj.ItemProperties.push( {"ItemPropertyName": row, "ItemPropertyValue": param[row]} )
            }
            break
        case "RemoveItem":
            obj.ItemId = param
            break
    }

    return obj
}

Vue.prototype.$getColor = function(value) {
    let arr = value.split(',')
    let rgb = arr[2] | (arr[1] << 8) | (arr[0] << 16);
    return "#" + (0x1000000 + rgb).toString(16).slice(1)
}

Vue.prototype.$tarifDict = null
Vue.prototype.$customerGroupDict = null
Vue.prototype.$zonesDict = null
Vue.prototype.$alarms = [
    { id: 1, icon: 'el-icon-info', color: 'color-blue', status: 'Information', text: 'Информация', size: '16px' },
    { id: 2, icon: 'el-icon-warning', color: 'color-warning', status: 'Warning', text: 'Предупреждение', size: '16px' },
    { id: 3, icon: 'el-icon-error', color: 'color-danger', status: 'Alarm', text: 'Ошибка', size: '16px' },
    { id: 4, icon: 'fa fa-mobile', color: 'color-success', status: 'Ok', text: 'Норма', size: '20px' },
    { id: 999, icon: 'el-icon-question', color: 'color-gray', status: 'Unknown', text: 'Неопределена', size: '18px' },
]
Vue.prototype.$statuses = [
    { color: 'color-success', status: 'Normal', text: 'В норме' },
    { color: 'color-gray', status: 'Offline', text: 'Не в сети' },
    { color: 'color-danger', status: 'Alarm', text: 'С тревогами' },
    { color: 'color-warning', status: 'Warning', text: 'С предупреждениями' },
    { color: 'color-blue', status: 'Unknown', text: 'Не опрашивается' }
]

Vue.prototype.$mobile = function () {
    return (document.body.clientWidth < 500 ? false : true)
}
Vue.prototype.$loginType = function () {
    return parseInt(sessionStorage.getItem('loginType'))
}

Vue.config.productionTip = false
let app = null
Vue.use(moment)

Vue.prototype.$today = [
    Vue.moment().format('YYYY-MM-DD 00:00'),
    Vue.moment().add(1, 'day').format('YYYY-MM-DD 00:00')
]

store.commit('addRoutes', routes)
//store.getters.routes.forEach(route => router.addRoute(route))
//router.addRoutes(store.getters.routes)

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    next()
})

Vue.mixin({
    methods: {
        ...showErrors
    }
})
Vue.filter('date', function (value) {
    if (!value) return ''
    if (app.$moment(value).diff('0001-01-01T00:00:00', 'seconds') <= 0 ) {
        return 'Нет'
    }
    return app.$moment(value).format('DD.MM.YYYY HH:mm')
})
Vue.filter('time', function (value) {
    if (!value) return ''
    return app.$moment(value).format('HH:mm')
})
Vue.filter('dateshort', function (value) {
    if (!value) return ''
    return app.$moment(value).format('DD.MM.YYYY')
})
Vue.filter('rubles', function (value) {
    if (!value) return '0 ₽'
    return value + ' ₽'
})

Vue.component('dateTimePicker', dateTimePicker)
Vue.component('TableDate', TableDate)
Vue.component('Icon', Icon)
Vue.component('ItemViewTable', ItemViewTable)
Vue.component('report', Report)
Vue.component('filters', Filters)
Vue.component('card', Card)
Vue.component(VueQrcode.name, VueQrcode)

// eslint-disable-next-line no-new
app = new Vue({
    el: "#app",
    data: {},
    store,
    router,
    render: h => h(App)
})
